import {auth, db} from "../services/firebase";

export function signup (email, password) {
    return auth().createUserWithEmailAndPassword(email, password);
}

export function signIn(email, password) {
    return auth().signInWithEmailAndPassword(email, password);
}

export function signInWithGoogleAccount () {
    const provider = new auth.GoogleAuthProvider();
    return auth().signInWithPopup(provider);
}

export function logout() {
    return auth().signOut();
}

export async function setOfflineUser (user) {
    if (user) {
        await db.ref('users').orderByChild('uid').equalTo(auth().currentUser.uid).once('value', async snapshot => {

            const key = Object.keys(snapshot.val())[0];
            console.log(key)
            await db.ref(`users/${key}`).set({
                ...snapshot.val()[key],
                online: false
            });
        })
    }
}
